import { Component, computed, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { VacationYtdAdjustment } from '@app/models/payroll/vacation-ytd-adjuster.model';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { NotifyService, PayrollService } from '@app/services';
import { PayrollModuleMenuService } from '../../services/payroll-module-menu.service';
import { VacationYtdAdjusterTable } from '../../services/tables/vacation-ytd-adjuster-table/vacation-ytd-adjuster.table';

@Component({
    templateUrl: './vacation-ytd-adjuster.template.html',
})
export class VacationYtdAdjusterView implements OnInit {
    isLoading = true;
    displayVacationYtdAdjusterTable = false;
    vacationYtdAdjusterTable: VacationYtdAdjusterTable;
    pendingPayrollExists = signal(false);

    pendingPayroll = computed(() => {
        return this.pendingPayrollExists();
    });
    showWarning = computed(() => {
        return !this.pendingPayrollExists();
    });

    constructor(
        private router: Router,
        private payrollService: PayrollService,
        private notify: NotifyService,
        public payrollModuleMenuService: PayrollModuleMenuService
    ) {}

    async ngOnInit(): Promise<void> {
        try {
            this.pendingPayrollExists.set(await this.hasPendingPayroll());
            this.vacationYtdAdjusterTable = new VacationYtdAdjusterTable(this.pendingPayrollExists());
            this.displayVacationYtdAdjusterTable = true;
            this.isLoading = false;
        } catch (error) {
            this.notify.error(error);
            this.isLoading = false;
        }
    }

    menuAction(event: MenuColumnEvent): void {
        const { menuItem, data } = event;
        const vacationYtdAdjustment = data as VacationYtdAdjustment;

        switch (menuItem.event) {
            case 'makeAdjustment':
                this.router.navigate([
                    '/payroll/vacation-ytd-adjuster/make-adjustment/' + vacationYtdAdjustment.employee.id,
                ]);
                break;
        }
    }

    async hasPendingPayroll(): Promise<boolean> {
        const pendingPayrollStatus = await this.payrollService.getPendingPayrollStatus();
        return pendingPayrollStatus.exists;
    }
}
